import { useEffect } from 'react'
import { diff } from 'deep-object-diff'
import { useFormikContext } from 'formik'

interface Props {
  debounceMs?: number
  onValuesDiffChange: (valuesAreDifferent: boolean) => void
}

function FormikValuesChangeListener({
  debounceMs = 500,
  onValuesDiffChange,
}: Props) {
  const { initialValues, values } = useFormikContext()

  useEffect(() => {
    const t = setTimeout(() => {
      const diffKeysCount = Object.keys(
        diff(values as any, (initialValues as any) || {}),
      ).length

      if (diffKeysCount) {
        onValuesDiffChange(true)
      } else {
        onValuesDiffChange(false)
      }
    }, debounceMs)

    return () => clearTimeout(t)
  }, [debounceMs, initialValues, onValuesDiffChange, values])

  return null
}

export { FormikValuesChangeListener }
